module.exports = __webpack_public_path__ + "img/90.80c05960.jpg";